import { render, staticRenderFns } from "./AccountProperties.vue?vue&type=template&id=04995c99&"
import script from "./AccountProperties.vue?vue&type=script&lang=js&"
export * from "./AccountProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04995c99')) {
      api.createRecord('04995c99', component.options)
    } else {
      api.reload('04995c99', component.options)
    }
    module.hot.accept("./AccountProperties.vue?vue&type=template&id=04995c99&", function () {
      api.rerender('04995c99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/AccountProperties.vue"
export default component.exports